import { Vector } from './Vector';
import { Rotation } from './Transform/Rotation';
export class ElementPosition {
    constructor(name) {
        if (!ElementPosition.allowedPosition.includes(name)) {
            throw new Error('bad element position');
        }
        this.namePosition = name;
    }
    static getVector(el, elementPosition) {
        let vector;
        switch (elementPosition.namePosition) {
            case 'tl':
                vector = new Vector(0, 0);
                break;
            case 'tr':
                vector = new Vector(el.size.width, 0);
                break;
            case 'bl':
                vector = new Vector(0, el.size.height);
                break;
            case 'br':
                vector = new Vector(el.size.width, el.size.height);
                break;
            case 'mr':
                vector = new Vector(el.size.width, el.size.height / 2);
                break;
            case 'mt':
                vector = new Vector(el.size.width / 2, 0);
                break;
            case 'mb':
                vector = new Vector(el.size.width / 2, el.size.height);
                break;
            case 'ml':
                vector = new Vector(0, el.size.height / 2);
                break;
            case 'mtr':
                vector = new Vector(el.size.width / 2, -this.rotationHandleVerticalOffset);
                break;
            case 'center':
                vector = new Vector(el.size.width / 2, el.size.height / 2);
                break;
            default:
                throw new Error('bad element position. ElementPosition has a bad configuration :o');
        }
        return vector;
    }
    getPosition(el) {
        // if (el instanceof ElementHandle && ((<ElementHandle>el).relativePos.namePosition == 'tr' && this.namePosition == 'tr')) {
        //     // DebugTools.drawVector(el.pos, ElementPosition.getVector(el, el.referencePosition).invert());
        //     // DebugTools.drawVector(el.pos.clone().applyVector(ElementPosition.getVector(el, el.referencePosition).invert())
        //     //     , ElementPosition.getVector(el, this));
        //     DebugTools.drawPosition(el.pos.clone()
        //         .applyVector(ElementPosition.getVector(el, el.referencePosition).invert())
        //         .applyVector(ElementPosition.getVector(el, this)));
        // }
        // if (el instanceof ElementHandle && (
        //     (<ElementHandle>el).relativePos.namePosition == 'tl' && this.namePosition == 'tl'
        //     || (<ElementHandle>el).relativePos.namePosition == 'br' && this.namePosition == 'br'
        //     || (<ElementHandle>el).relativePos.namePosition == 'bl' && this.namePosition == 'bl')) {
        //     // DebugTools.drawVector(el.pos, ElementPosition.getVector(el, el.referencePosition).invert());
        //     // DebugTools.drawVector(el.pos.clone().applyVector(ElementPosition.getVector(el, el.referencePosition).invert())
        //     //     , ElementPosition.getVector(el, this));
        //     DebugTools.drawPosition(el.pos.clone()
        //         .applyVector(ElementPosition.getVector(el, el.referencePosition).invert())
        //         .applyVector(ElementPosition.getVector(el, this)), 2, 'red');
        // }
        return Rotation.rotatePoint(
            el.rotation.angle,
            el.pos
                .applyVector(ElementPosition.getVector(el, el.referencePosition).invert())
                .applyVector(ElementPosition.getVector(el, this)),
            el.pos
        );
    }
}
ElementPosition.allowedPosition = ['mr', 'ml', 'mt', 'mb', 'mtr', 'center', 'tr', 'tl', 'br', 'bl'];
ElementPosition.rotationHandleVerticalOffset = 0.05;
